import {
  ArrowsClockwiseIcon,
  ArrowsLeftRightIcon,
  CheckCircleIcon,
  CoinsIcon,
  MagnifyingGlassIcon,
  PencilSimpleIcon,
} from '@phosphor-icons/react'

import { ContactCustomerIcon } from '@reveni-io/reveni-ui'

import {
  actionRequiredPermission,
  availableActions,
  availableAlerts,
  disabledActionInfoSeparator,
  markAsResolvedRequiredPermission,
} from './constants'

const findAvailableAlerts = alert => availableAlerts.find(entry => entry.code === alert?.type)

export const getAlertTitle = (alert, t) => {
  const availableAlert = findAvailableAlerts(alert)

  if (!availableAlert) return null

  return t(availableAlert.title, {
    reason: alert?.properties?.reason,
    notes: alert?.properties?.notes?.join(', '),
  })
}

const getRequiredPermission = (action, alert) => {
  if (action.code === availableActions.markAsResolved) return markAsResolvedRequiredPermission[alert.type]

  return actionRequiredPermission[action.code]
}

const isActionAllowed = (action, alert, hasPermission, storeId) => {
  const requiredPermission = getRequiredPermission(action, alert)

  if (!requiredPermission) return true

  return hasPermission(requiredPermission, storeId)
}

export const getAlertActions = ({
  alert,
  t,
  onClickMissingCustomsData,
  onClickIssueRefund,
  onClickCreateExchangeOrder,
  onClickMarkAsResolved,
  onClickContactCustomer,
  onClickReviewAdditionalReturnedProducts,
  onClickEditAddressAndRetryLabel,
  onClickRetryLabel,
  isRetryLabelHidden,
  isRetryLabelDisabled,
  hasPermission,
  storeId,
}) => {
  const availableAlert = findAvailableAlerts(alert)

  if (!availableAlert) return []

  const allActions = [
    {
      code: availableActions.editCustomsData,
      id: 'editCustomsData',
      label: t('Editar información de aduanas'),
      icon: <PencilSimpleIcon size={16} />,
      onClick: onClickMissingCustomsData,
    },
    {
      code: availableActions.editAddressAndRetryLabel,
      id: 'editAddressAndRetryLabel',
      label: t('Editar dirección y reintentar'),
      icon: <PencilSimpleIcon size={16} />,
      onClick: onClickEditAddressAndRetryLabel,
      hidden: isRetryLabelHidden,
      disabled: isRetryLabelDisabled,
    },
    {
      code: availableActions.retryLabel,
      id: 'retryLabel',
      label: t('Reintentar'),
      icon: <ArrowsClockwiseIcon size={16} />,
      onClick: onClickRetryLabel,
      hidden: isRetryLabelHidden,
      disabled: isRetryLabelDisabled,
    },
    {
      code: availableActions.issueRefund,
      id: 'issueRefund',
      label: t('Emitir reembolso'),
      icon: <CoinsIcon size={16} />,
      onClick: () => onClickIssueRefund(alert),
    },
    {
      code: availableActions.createExchangeOrder,
      id: 'createExchangeOrder',
      label: t('Crear pedido de cambio'),
      icon: <ArrowsLeftRightIcon size={16} />,
      onClick: onClickCreateExchangeOrder,
    },
    {
      code: availableActions.markAsResolved,
      id: 'markAsResolved',
      label: t('Marcar como resuelto'),
      icon: <CheckCircleIcon size={16} />,
      onClick: () => onClickMarkAsResolved(alert),
    },
    {
      code: availableActions.contactCustomer,
      id: 'contactCustomer',
      label: t('Contactar con el cliente'),
      icon: <ContactCustomerIcon size={16} />,
      onClick: onClickContactCustomer,
    },
    {
      code: availableActions.reviewAdditionalReturnedProducts,
      id: 'reviewAdditionalReturnedProducts',
      label: t('Revisar productos devueltos adicionales'),
      icon: <MagnifyingGlassIcon size={16} />,
      onClick: onClickReviewAdditionalReturnedProducts,
    },
  ]

  return allActions
    .filter(action => availableAlert.availableActions.includes(action.code))
    .filter(action => !action.hidden)
    .filter(action => isActionAllowed(action, alert, hasPermission, storeId))
}

export const getDisabledActionExtraInfo = (actions, disabledReason) => {
  const hasDisabledAction = actions.some(action => action.disabled)

  if (!hasDisabledAction || !disabledReason) return null

  return `${disabledActionInfoSeparator}${disabledReason}`
}
